import React from 'react';
import Header from './components/headers';
import styled from 'styled-components';
import Main from './components/main/Main';
import Footer from './components/footer';
import MenuContextProvider from './contexts/MenuContext';
import AuthContextProvider from './contexts/AuthContext';
import { BrowserRouter } from 'react-router-dom';


const Content = styled.div`
   width: 80%;
   margin: 0 auto;
   max-width: 800px;
`;

function App() {
  return (
      <MenuContextProvider><AuthContextProvider>
      <div className="App">
      	<Content>
          <BrowserRouter>
          	<Header />
            <Main />
          </BrowserRouter>
        </Content>
        <Footer />
      </div>
      </AuthContextProvider></MenuContextProvider>
  );
}

export default App;
